import React from 'react';

import { useQuery } from '@tanstack/react-query';
import QRCode from 'qrcode.react';

import getResizedQRLogoUrl from '../../../helpers/getResizedQRLogoUrl';
import AdminService from '../../../services/AdminService';

export default function QRCodeGenerator({ value, size, imageSize }) {
  const { data } = useQuery({
    queryKey: ['tenantSettings'],
    queryFn: AdminService.getTenantSettings,
  });

  const logoUrl = data?.brand?.logo
    ? getResizedQRLogoUrl({
        url: `brand/${data.brand.logo.split('/').pop()}`,
        width: imageSize?.width || 86,
        height: imageSize?.height || 39,
      })
    : null;

  return (
    <QRCode
      renderAs="svg"
      value={value}
      size={size || 150}
      level="H"
      imageSettings={{
        src: logoUrl,
        height: imageSize?.height || 39,
        width: imageSize?.width || 86,
        excavate: true,
      }}
    />
  );
}
